import { render } from "./AddUserToProduct.vue?vue&type=template&id=c0879a9a"
import script from "./AddUserToProduct.vue?vue&type=script&lang=js"
export * from "./AddUserToProduct.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafedenj-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__